import React from "react";

import { withStyles, Styles } from "./styles";
import { REVIEW_SECTION_ID } from "../../../constants";

const BaseSectionAnchor: React.FC<Styles> = ({ children, classes }) => (
  <div className={classes.containerRelative}>
    <div id={REVIEW_SECTION_ID} className={classes.containerAbsolute}>
      {children}
    </div>
  </div>
);

export const SectionAnchor = withStyles(BaseSectionAnchor);
